import * as React from 'react'
import * as css from './TestimonialBlock.module.css'
import SanityBlock from 'components/common/SanityBlock'

const TestimonialBlock = ({ quote, author, title }) => (
  <blockquote className="richtext">
    <div className={css.quote}>
      <SanityBlock body={quote} />
    </div>

    <footer>
      {author && <p className="technical">— {author}</p>}
      {title && <p className="technical">{title}</p>}
    </footer>
  </blockquote>
)

export default TestimonialBlock
